import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';

/**
 * Attaches the bearer token to every call against our own API (never to the i18n loader or any
 * third-party request), and drops the session on a 401 — the token is either expired or the API
 * rejected it outright, so there's nothing useful left to retry with.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const isApiCall = req.url.startsWith(environment.apiUrl);
  const token = auth.token();
  const authedReq = isApiCall && token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(authedReq).pipe(
    catchError((err) => {
      if (isApiCall && err?.status === 401) {
        auth.logout();
        router.navigateByUrl('/auth/login');
      }
      return throwError(() => err);
    }),
  );
};
